import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=e7b61462&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7b61462')) {
      api.createRecord('e7b61462', component.options)
    } else {
      api.reload('e7b61462', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=e7b61462&", function () {
      api.rerender('e7b61462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4R375Y0VliM7T/JS/comp/IncreaseNumber.vue"
export default component.exports